import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EntityAppService from '../../../../application/platform/scp/entity/entitiy-app-service';
import { ACTION_TYPES, useUnidEntityCreateDispatch, useUnidEntityCreateState } from './unid-entity-create-context';
import { useBaseLayout } from '../../../../components/context/use-base-layout';

export const useUnidEntityCreateController = () => {
    const navigate = useNavigate();
    const { showLoading, showMessage } = useBaseLayout();
    const [isSaving, setIsSaving] = useState(false);
    const dispatch = useUnidEntityCreateDispatch();
    const state = useUnidEntityCreateState();

    function handleOnChange(e: any) {
        let unitCode = state.request?.unitCode;
        let ibgeCode = state.request.ibgeCode;
        let name = state.request.name;

        if (e.target.name === "input-unit-code") {
            unitCode = e.target.value;
        } else if (e.target.name === "input-ibge-code") {
            ibgeCode = e.target.value;
        } else if (e.target.name === "input-name") {
            name = e.target.value;
        }

        dispatch({
            type: ACTION_TYPES.updateRequest,
            payload: { unitCode, ibgeCode, name }
        });
    }

    function validFields(): boolean {
        let isValid = true;

        if (state.request.name === undefined || state.request.name.length === 0) {
            isValid = false;
        }
        if (state.request.unitCode === undefined || state.request.unitCode.length === 0) {
            isValid = false;
        }
        if (state.request.ibgeCode === undefined || state.request.ibgeCode.length === 0) {
            isValid = false;
        }
        return isValid;
    }

    async function handleSave() {
        if (!validFields()) {
            dispatch({ type: ACTION_TYPES.setShowValidationErrors, payload: true });
            showMessage({ open: true, message: "Preencha todos os campos obrigatórios", type: "error" });
            return;
        }

        setIsSaving(true);
        try {
            showLoading({ open: true });
            await EntityAppService.addUnidEntity(state.request);
            showLoading({ open: false });
            showMessage({ open: true, message: "Unidade da entidade salva com sucesso", type: "success" });

            // Navega para a tela de consultas após salvar
            setTimeout(() => {
                navigate('/unidades-entidade');
            }, 1000);
        } catch (error) {
            showLoading({ open: false });
            showMessage({
                open: true,
                message: "Não foi possível salvar a unidade da entidade",
                detail: (error as any).details || (error as Error).message,
                type: "error"
            });
        } finally {
            setIsSaving(false);
        }
    }

    return {
        handleOnChange,
        handleSave,
        isSaving
    };
}
